import { render } from "./SentMessageComponent.vue?vue&type=template&id=003524ac&scoped=true"
import script from "./SentMessageComponent.vue?vue&type=script&lang=js"
export * from "./SentMessageComponent.vue?vue&type=script&lang=js"

import "./SentMessageComponent.vue?vue&type=style&index=0&id=003524ac&scoped=true&lang=css"
import "../assets/css/scroll.css?vue&type=style&index=1&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-003524ac"]])

export default __exports__